<ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>
@if (!isLoading) {
  <ziro-collapsible-section-card [isSwitchHidden]="true" [isCollapsible]="false">
    <div>
      <ziro-fieldset-header [legend]="'tkey;pages.details.phoneSettings.header' | translate">
        <ziro-phone-model-protocol-form
          [entity]="modelProtocolFormData"
          [fieldConfig]="modelProtocolFieldConfig"
          [phoneType]="phoneType"
          [isGeneratingPhone]="
            loadingSubscriptions.phoneFieldConfig || (!phone.ctiAssociatedEndUsers && !!phone.protocol)
          "
          (modelProtocolUpdate$)="onModelProtocolFormUpdate($event)"
        ></ziro-phone-model-protocol-form>
        @if (fieldConfig && !isLoadingPhoneFields) {
          <ziro-phone-fields-form
            [cucmServerId]="cucmServerId"
            [endUserRef]="endUserRef"
            [phoneType]="phoneType"
            [fieldConfig]="fieldConfig"
            [entity]="phoneFieldsEntity"
            [isGeneratingPhone]="loadingSubscriptions.phoneFieldConfig || !phone.ctiAssociatedEndUsers"
            (ziroFormsUpdate$)="onPhoneFieldsChange($event)"
            [attr.data-automation]="'phone-fields-form'"
            [isFormStateInvalid]="isFormStateInvalid"
            [isErrorThrown]="isErrorThrown"
          >
            @if (
              phone.model &&
              phone.protocol &&
              phone.buttons.length > 0 &&
              !loadingSubscriptions.phoneFieldConfig &&
              !isAutomaticPhoneButtonTemplateMode &&
              possiblePhoneButtonTemplates
            ) {
              <ziro-phone-button-template-form
                [entity]="phoneButtonTemplateEntity"
                [possibleOptions]="possiblePhoneButtonTemplates"
                [isErrorThrown]="false"
                (ziroFormsUpdate$)="onPhoneButtonTemplateChange($event)"
              ></ziro-phone-button-template-form>
            }
          </ziro-phone-fields-form>
        }
      </ziro-fieldset-header>
      @if (fieldConfig?.phoneServices && (fieldConfig.phoneServices.show || isExistingPhoneWithServiceSubscriptions)) {
        <ziro-phone-services-form
          [hidden]="loadingSubscriptions.phoneFieldConfig || !phone.ctiAssociatedEndUsers"
          [serviceSubscriptionFieldConfig]="fieldConfig?.phoneServices"
          [entity]="phone.serviceSubscriptions"
          (ziroFormsUpdate$)="onPhoneServiceSubscriptionsChange($event)"
        ></ziro-phone-services-form>
      }
      @if (loadingSubscriptions.phoneFieldConfig) {
        <ziro-loading-block data-automation="phone-buttons-loading-block"></ziro-loading-block>
      }
      @if (phone.model && phone.protocol && phone.buttons.length > 0 && !loadingSubscriptions.phoneFieldConfig) {
        <div data-automation="phone-buttons-container">
          @if (phoneButtonTemplateFieldConfig) {
            <ziro-phone-buttons
              [userMode]="DragDropMode.HELPDESK"
              [global360View]="global360View()"
              [siteId]="siteId"
              [serverId]="cucmServerId.toString()"
              [templateButtons]="phoneButtonTemplateFieldConfig.buttons"
              [isPending]="isPhoneButtonTemplateChangePending"
              [attr.data-automation]="'phone-buttons-form'"
              [fieldConfig]="phoneFieldConfig"
              [endUserRef]="endUserRef"
              [phoneType]="phoneType"
              [phoneButtonTemplateConfig]="phoneButtonTemplateFieldConfig"
              [isAutomaticPhoneButtonTemplateSelectionEnabled]="isAutomaticPhoneButtonTemplateMode"
              [isEnhancedLineModeOn]="isDisplayEnhancedLineMode"
              (validationStateSubject)="onPhoneButtonValidationStateChange($event)"
              (expansionModuleSelected)="onExpansionModuleSelected($event)"
            ></ziro-phone-buttons>
          }
        </div>
      }
    </div>
  </ziro-collapsible-section-card>
}
